import styled from 'styled-components';

export const Editor = styled.div`
  background: transparent;
  outline: 0;

  &:empty:before {
    content: attr(placeholder);
    pointer-events: none;
    display: block; /* For Firefox */
    color: var(--gray-500);
  }
`;

Editor.displayName = 'Editor';

type isMediaCommentProps = {
  isMediaComment?: boolean;
};

export const ImageContainer = styled.div<isMediaCommentProps>`
  max-width: ${(props) => !props.isMediaComment && '480px'};
  margin: ${(props) => !props.isMediaComment && '0 auto'};
`;

ImageContainer.displayName = 'ImageContainer';

export const IconContainer = styled.div<isMediaCommentProps>`
  top: ${(props) => (props.isMediaComment ? '10px' : '12px')};
  right: ${(props) => !props.isMediaComment && '13px'};
  left: ${(props) => props.isMediaComment && '107px'};
  width: var(--spacer-6);
  height: var(--spacer-6);
  cursor: pointer;
  z-index: 2;
`;

IconContainer.displayName = 'IconContainer';

export const LinkPreviewContainer = styled.div`
  .Container {
    flex-direction: row-reverse;
    background-color: var(--gray-100) !important;

    .Image {
      width: 20%;
      height: 15vh;
    }

    .LowerContainer {
      width: 80%;

      .Title {
        color: var(--gray-900);
        font-size: var(--text-1);
      }
    }
  }
`;

LinkPreviewContainer.displayName = 'LinkPreviewContainer';

export const AvatarContainer = styled.div`
  height: 32px;
  width: 32px;
  background-color: var(--gray-200);
  border-radius: 50%;

  .img-avatar {
    height: 32px;
    width: 32px;
    border-radius: 50%;
  }
`;

AvatarContainer.displayName = 'AvatarContainer';
